<template>
  <b-modal v-model="show" size="xl" centered no-close-on-backdrop header-class="bg-modal-header">

    <template #modal-header>
      <div class="fw-bold">충전기별 이용현황 비교 (최근 30일)</div>
    </template>

    <b-form-radio-group
        v-model="selected"
        :options="options"
        class="my-3"
        plain
        @input="changeOpt"
    ></b-form-radio-group>

    <div class="card ps-3">
      <div class="row justify-content-center">
        <div id="sumChartSection" class="col-lg-4">
          <apexchart ref="usageSumChart" height="400" :options="usageSumChartOptions"
                     :series="usageSumChartOptions.series"/>
        </div>
        <div id="monthChartSection" class="col-lg-8">
          <apexchart ref="usageMonthChart" height="400" :options="usageMonthChartOptions"
                     :series="usageMonthChartOptions.series"/>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100">
        <b-button variant="secondary" class="float-end w-xs p-1" @click="show=false">닫기</b-button>
      </div>
    </template>

  </b-modal>
</template>

<script>
export default {
  name: "recentUsageStatus",
  props: {
    placeId: String,
  },
  data() {
    const _eApi = this.$_app.service.evseUse;

    return {
      evseApi: _eApi,
      show: false,
      selected: 'userCount',
      today : this.$moment(new Date()).format('YYYY-MM-DD'),
      totalChartData : {},
      sortedDataBySum: [],
      options: [
        { text: '이용자 수', value: 'userCount' },
        { text: '이용 건수', value: 'usedCount' },
        { text: '충전량 (kWh)', value: 'totEnergy' },
        { text: '충전요금 (원)', value: 'totCost' }],
      fields:[
        { key: '충전기', sortable: true },
        { key: '총 합', sortable: true },],
      items: [],
      chartColors: ['#33B2DF', '#546E7A', '#D4526E', '#13D8AA', '#F9A3A4', '#2B908F','#f1b55a', '#90EE7E', '#69D2E7', '#ec4b4a'],
      selectedDataIdx: [],
      usageSumChartOptions:  {
        chart: {
          type: 'bar',
          fontFamily: 'NanumSquareRound',
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: (e, chart, opts) => this.selectData(e, chart, opts),
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
          },
        },
        dataLabels: { enabled: false },
        xaxis: {
          type: 'category',
          categories: [],
          labels: {
            hideOverlappingLabels: false,
            formatter: val => this.$_utils.comma(Math.round(val * 10) / 10),
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: [{
          labels: {
            show: true,
            style: {
              fontSize: '12px',
              fontWeight: 600,
            }
          },
        }],
        series: [],
        colors: [],
        fill: {
          opacity: 1,
        },
        stroke: {
          show: true,
          width: 2,
        },
        noData: {
          text: 'No Data',
          offsetY: -10,
        },
        legend: {
          show: false,
        },
        states: {
          normal: {
            filter: {
              type: 'desaturate',
            }
          },
          active: {
            allowMultipleDataPointsSelection: true,
            filter: {
              type: 'none',
            }
          },
        },
        tooltip: {
          x: {
            show: false
          },
          y: {
            title: {
              formatter: (val, opts) => opts.w.globals.labels[opts.dataPointIndex],
            }
          }
        },
      },
      usageMonthChartOptions: {
        chart: {
          type: 'bar',
          fontFamily: 'NanumSquareRound',
          stacked: true,
          toolbar: { show: false },
          zoom: { enabled: false }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              total: {
                enabled: false,
                formatter: val => val !==0 ? val : '',
                style: {
                  fontSize: '10px',
                  fontWeight: 900
                }
              }
            }
          },
        },
        dataLabels: {enabled: false},
        xaxis: {
          type: 'category',
          categories: [],
          labels: {
            hideOverlappingLabels: false,
            maxHeight: 40,
          },
          axisTicks: { show: false },
          tooltip: { enabled: false },
        },
        yaxis: [{
          labels: {
            formatter: undefined,
            maxWidth: 200,
          },
        }],
        series: [],
        colors: [],
        noData: {
          text: 'No Data',
          offsetY: -10,
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          showForNullSeries: false,
          offsetY: 10,
          position: 'right',
          markers: {
            width: 15,
            height: 2,
            offsetY: -3,
          },
        },
        tooltip: {
          y: {
            title: { formatter: seriesName => `${seriesName}` },
            formatter: undefined,
          },
        },
      },
    }
  },
  watch: {
    placeId: {
      immediate: true,
      handler() {
        const vm = this;
        vm.getTotalChartData();
      }
    },
    show(val) {
      const vm = this;

      if (val === true) {
        vm.selected = 'userCount';
        vm.selectedDataIdx = [];
        vm.$nextTick(()=>vm.changeOpt());
      }
    }
  },
  methods: {
    async getTotalChartData() {
      const vm = this;

      try {
        const res = await vm.evseApi.requestUsedStatChart(vm.placeId, vm.today);

        vm.totalChartData =  Object.assign({}, res.items);
        // console.log('placeId',vm.placeId)
        // console.log('totalChartData',vm.totalChartData)

        vm.usageSumChartOptions.colors = vm.chartColors;
        vm.usageMonthChartOptions.xaxis.categories = [...res.items.day]

      } catch (err) {
        console.log(err);
      }
    },
    changeOpt() {
      const vm = this;

      if (vm.selectedDataIdx.length > 0) {
        vm.clearSelectData();
      }

      vm.sortSumData();
      vm.selectData('','', {  dataPointIndex: 0 });
      vm.updateUsageSumChart();
    },
    clearSelectData() {
      const vm = this;

      vm.selectedDataIdx.forEach(ele => {
        vm.$refs.usageSumChart.toggleDataPointSelection(0, ele)
      });
      vm.selectedDataIdx = [];
    },
    sortSumData() {
      const vm = this;

      vm.sortedDataBySum = vm.totalChartData[`${vm.selected}`].sort((a, b) => {
        const aSum = Object.values(a)[0].reduce((a, b) => a + b, 0);
        const bSum = Object.values(b)[0].reduce((a, b) => a + b, 0);

        return bSum - aSum;
      });

      const sumData = vm.sortedDataBySum.map(ele => (
        { [Object.keys(ele)[0]] : Object.values(ele)[0].reduce((a, b) => a + b, 0) }
      ));

      const chargerList = sumData.map(ele => Object.keys(ele)[0]);
      const data = sumData.map(ele => Object.values(ele)[0]);

      vm.usageSumChartOptions.series = [{ data: [...data] }];
      vm.usageSumChartOptions.xaxis.categories = [...chargerList];
    },
    selectData(e, chart, opts) {
      const vm = this;
      const sumChartSection = document.querySelector('#sumChartSection');
      const monthChartSection = document.querySelector('#monthChartSection');

      const includeIdx = vm.selectedDataIdx.indexOf(opts.dataPointIndex);

      if (includeIdx > -1) {
        vm.selectedDataIdx.splice(includeIdx, 1);
      } else {
        vm.selectedDataIdx.push(opts.dataPointIndex);
      }

      if (vm.usageSumChartOptions.series[0].data.every(val => val === 0)) {
        vm.selectedDataIdx = [];
      }

      if (vm.selectedDataIdx.length > 0) {
        if (monthChartSection.classList.contains('d-none')) {
          sumChartSection.classList.remove('col-lg-8');
          monthChartSection.classList.remove('d-none');
        }
        vm.updateUsageMonthChart();
      } else {
        sumChartSection.classList.add('col-lg-8');
        monthChartSection.classList.add('d-none');
      }
    },
    updateUsageSumChart() {
      const vm = this;

      if (vm.selected === 'userCount') {
        vm.usageSumChartOptions.tooltip.y.formatter = y => `${this.$_utils.comma(y)}명`;

      } else if (vm.selected === 'usedCount') {
        vm.usageSumChartOptions.tooltip.y.formatter = y => `${this.$_utils.comma(y)}건`;

      } else if (vm.selected === 'totEnergy') {
        vm.usageSumChartOptions.tooltip.y.formatter = y => `${this.$_utils.comma(Math.round(y * 100) / 100)}kWh`;

      } else if (vm.selected === 'totCost') {
        vm.usageSumChartOptions.tooltip.y.formatter = y => `${y.toLocaleString('ko-KR')}원`;

      }

      vm.$refs.usageSumChart.updateOptions(vm.usageSumChartOptions);
    },
    updateUsageMonthChart() {
      const vm = this;

      if (vm.selected === 'userCount') {
        vm.usageMonthChartOptions.tooltip.y.formatter = y => `${this.$_utils.comma(y)}명`;
        vm.usageMonthChartOptions.yaxis[0].labels.formatter = val => val.toFixed(0);

      } else if (vm.selected === 'usedCount') {
        vm.usageMonthChartOptions.tooltip.y.formatter = y => `${this.$_utils.comma(y)}건`;
        vm.usageMonthChartOptions.yaxis[0].labels.formatter = val => val.toFixed(0);

      } else if (vm.selected === 'totEnergy') {
        vm.usageMonthChartOptions.tooltip.y.formatter = y => `${this.$_utils.comma(Math.round(y * 100) / 100)}kWh`;
        vm.usageMonthChartOptions.yaxis[0].labels.formatter = val => val.toFixed(0);

      } else if (vm.selected === 'totCost') {
        vm.usageMonthChartOptions.tooltip.y.formatter = y => `${y.toLocaleString('ko-KR')}원`;
        vm.usageMonthChartOptions.yaxis[0].labels.formatter = val => val.toLocaleString('ko-KR');

      }

      const _series = vm.selectedDataIdx.map(ele => (
        { 'name': Object.keys(vm.sortedDataBySum[ele])[0],
          'data': Object.values(vm.sortedDataBySum[ele])[0] }
      ));
      const _colors = vm.selectedDataIdx.map(ele => vm.chartColors[ele]);

      vm.usageMonthChartOptions.series = _series;
      vm.usageMonthChartOptions.colors = _colors;

      vm.$refs.usageMonthChart.updateOptions(vm.usageMonthChartOptions);
    },
  }
}
</script>